export * from './promotion-tag';
